import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=7dc7c556&scoped=true&"
import script from "./DocumentsView.vue?vue&type=script&lang=js&"
export * from "./DocumentsView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=7dc7c556&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc7c556",
  null
  
)

export default component.exports